import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-304dd279"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-article" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "loading-state"
}

import { ref, watchEffect, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import news from "@/shared/news";
import ImagePopup from "./ImagePopup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsComponent',
  setup(__props) {

const route = useRoute();
const isImageDialogOpen = ref(false);
const currentImage = ref("");
const newsId = ref(Number(route.params.id));
const newsPiece: any = ref(null);

const windowWidth = ref(window.innerWidth);

const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWindowWidth);
});

const isMobile = computed(() => windowWidth.value < 960);

function findNewsById(index: number) {
  return news.find((piece: any) => piece.index === index);
}

const showImageDialog = (imageUrl: string) => {
  currentImage.value = imageUrl;
  isImageDialogOpen.value = true;
};

const closeImageDialog = () => {
  isImageDialogOpen.value = false;
};

watchEffect(() => {
  newsId.value = Number(route.params.id);
  newsPiece.value = findNewsById(newsId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "news-title" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(newsPiece.value.title), 1)
                ]),
                _: 1
              }),
              (newsPiece.value.subtitle)
                ? (_openBlock(), _createBlock(_component_v_card_title, {
                    key: 0,
                    class: "news-subtitle"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(newsPiece.value.subtitle), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_divider, {
                thickness: 4,
                color: "#3AB54A",
                class: "border-opacity-100 mx-4 my-4"
              }),
              (isMobile.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "news-image-container",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showImageDialog(newsPiece.value.photo)))
                  }, [
                    _createElementVNode("img", {
                      src: newsPiece.value.photo,
                      class: "news-image",
                      alt: "News Image"
                    }, null, 8, _hoisted_2)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_card_text, { class: "news-text" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: newsPiece.value.text
                  }, null, 8, _hoisted_3)
                ]),
                _: 1
              }),
              (!isMobile.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "news-image-container",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showImageDialog(newsPiece.value.photo)))
                  }, [
                    _createElementVNode("img", {
                      src: newsPiece.value.photo,
                      class: "news-image",
                      alt: "News Image"
                    }, null, 8, _hoisted_4)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6",
            class: "news-text-container"
          }, {
            default: _withCtx(() => [
              (newsPiece.value.photo_2)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "news-image-container",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showImageDialog(newsPiece.value.photo_2)))
                  }, [
                    _createElementVNode("img", {
                      src: newsPiece.value.photo_2,
                      class: "news-image",
                      alt: "News Image 2"
                    }, null, 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              (newsPiece.value.text_2)
                ? (_openBlock(), _createBlock(_component_v_card_text, {
                    key: 1,
                    class: "news-text"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: newsPiece.value.text_2
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ImagePopup, {
        showPopup: isImageDialogOpen.value,
        selectedImage: currentImage.value,
        onClosePopup: closeImageDialog
      }, null, 8, ["showPopup", "selectedImage"])
    ]),
    (!newsPiece.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})